<template>
  <component class="smart icon" :is="dynamicIcon"/>
</template>

<script>
export default {
  name: "Smart-Icon",
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    dynamicIcon() {
      return this.$smart.iconAsync(this.icon)
    }
  }
};
</script>

<style>
svg.smart.icon{
  fill: currentColor;
  padding: 8px;
}

svg.smart.icon:only-child{
  width: inherit;
  height: inherit;
}
</style>

